module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACwSURBVEhL3ZTBCcJAEEUXbEPBoz3oXbATaxNsQmML3vUuqAXof5CFZVgwyE8O++DBZBjmhyyb1Byd/ATP0sZJxgB6VmKAnckDNhI4H8t5vGUMKYXy+SWPciUHwXC5IAq1/kPO5U94E4ZrSxBqfTzIQSwkw08Zl0DsZZn/G+5DvBNrGUPsjBrQxq9lEpa9ozCTl15qO3uZvz+1navMAdR27jIH3Gi42UlCWL6l0RIpfQGkc3Cat5tI0QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-piping/dark/24.png
// module id = 2332
// module chunks = 2